



































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import RetensiStore from "@/store/modules/RetensiAlihMediaStore";
import Service from "@/services/RetensiAlihMediaService";
import {
  RetensiSession,
  RetensiSignature,
  RetensiBeritaAcara,
  SignerRole,
  BeritaAcaraJenis,
  SignPayload,
} from "@/types/RetensiAlihMedia";

interface SignerCfg {
  role: SignerRole;
  label: string;
}

@Component({ name: "RetensiStepSignature" })
export default class StepSignature extends Vue {
  @Prop({ type: Object, default: null }) session!: RetensiSession | null;

  store = RetensiStore;
  signDialog = false;
  signing = false;
  finalizing = false;
  generatingBa: BeritaAcaraJenis | null = null;
  signCfg: SignerCfg | null = null;
  metodePemusnahan = "Shredder cross-cut";

  signerCards: SignerCfg[] = [
    { role: "pmik_pelaksana", label: "1. PMIK Pelaksana" },
    { role: "auditor", label: "2. Auditor" },
    { role: "karu_rm", label: "3. Ka. Unit RM" },
    { role: "direktur", label: "4. Direktur" },
    { role: "saksi_pemusnah_1", label: "Saksi Pemusnah 1" },
    { role: "saksi_pemusnah_2", label: "Saksi Pemusnah 2" },
    { role: "saksi_pemusnah_3", label: "Saksi Pemusnah 3" },
  ];

  signForm: SignPayload = {
    role: "pmik_pelaksana",
    password: "",
    signer_user_id: 0,
    signer_nama: "",
    signer_jabatan: "",
    signer_str_no: "",
  };

  get signed(): Record<string, RetensiSignature> {
    return this.store.signaturesByRole;
  }

  get baAlihMedia(): RetensiBeritaAcara | undefined {
    return this.session?.berita_acara?.find((b) => b.jenis === "alih_media");
  }

  get baPemusnahan(): RetensiBeritaAcara | undefined {
    return this.session?.berita_acara?.find((b) => b.jenis === "pemusnahan");
  }

  canSign(role: SignerRole): boolean {
    const status = this.session?.status;
    if (!status) return false;
    if (this.signed[role]) return false; // sudah TTD
    const sequence: Record<string, string[]> = {
      pmik_pelaksana: ["checklist_done"],
      auditor: ["signed_pmik"],
      karu_rm: ["signed_auditor"],
      direktur: ["signed_karu_rm"],
    };
    if (role.startsWith("saksi_pemusnah_")) {
      return ["signed_direktur"].includes(status) || !!this.signed.direktur;
    }
    return sequence[role]?.includes(status) ?? false;
  }

  get canGenerateBaAlihMedia(): boolean {
    return !!(
      this.signed.pmik_pelaksana &&
      this.signed.karu_rm &&
      this.signed.direktur
    );
  }

  get canGenerateBaPemusnahan(): boolean {
    return !!(
      this.signed.pmik_pelaksana &&
      this.signed.direktur &&
      this.signed.saksi_pemusnah_1 &&
      this.signed.saksi_pemusnah_2 &&
      this.signed.saksi_pemusnah_3
    );
  }

  get canFinalize(): boolean {
    return (
      this.session?.status === "signed_direktur" && !!this.baAlihMedia
    );
  }

  openSign(cfg: SignerCfg) {
    this.signCfg = cfg;
    this.signForm = {
      role: cfg.role,
      password: "",
      signer_user_id: 0,
      signer_nama: "",
      signer_jabatan: "",
      signer_str_no: "",
    };
    this.signDialog = true;
  }

  async doSign() {
    if (!this.session?.id || !this.signCfg) return;
    this.signing = true;
    try {
      await this.store.sign({
        sessionId: this.session.id,
        data: this.signForm,
      });
      this.signDialog = false;
      this.$emit("refresh");
    } finally {
      this.signing = false;
    }
  }

  async generateBa(jenis: BeritaAcaraJenis) {
    if (!this.session?.id) return;
    this.generatingBa = jenis;
    try {
      await this.store.createBeritaAcara({
        sessionId: this.session.id,
        data: {
          jenis,
          metode_pemusnahan:
            jenis === "pemusnahan" ? this.metodePemusnahan : undefined,
        },
      });
      this.$emit("refresh");
    } finally {
      this.generatingBa = null;
    }
  }

  openBaPdf(jenis: BeritaAcaraJenis) {
    if (!this.session?.id) return;
    window.open(Service.beritaAcaraPdfUrl(this.session.id, jenis), "_blank");
  }

  async doFinalize() {
    if (!this.session?.id) return;
    if (!confirm("Finalize akan mengunci session permanen. Lanjutkan?")) return;
    this.finalizing = true;
    try {
      await this.store.finalize(this.session.id);
      this.$emit("finalized");
    } finally {
      this.finalizing = false;
    }
  }

  formatDate(iso: string | null | undefined): string {
    if (!iso) return "—";
    return new Date(iso).toLocaleDateString("id-ID");
  }

  formatDateTime(iso: string | null | undefined): string {
    if (!iso) return "—";
    return new Date(iso).toLocaleString("id-ID");
  }
}
